<div class="main-modal upload-irs-modal gtw-web-components">
  <div class="modal-header">
    <h3 class="modal-title">Upload IRS Schema</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         (click)="minimise=!minimise"></i>
      <i (click)="closeModal(true)" class="fa fa-times"></i>
    </div>
  </div>

  <div class="upload-irs-modal-body modal-body" [hidden]="minimise">
    <form class="upload-irs-form">
      <div class="form-row">
        <label>Form:</label>
        <select class="form-control"
                name="formType"
                [(ngModel)]="uploadParams.formType">
          @for (rt of returnTypes; track $index) {
<option [ngValue]="rt.value">{{ rt.label }}</option>
}
        </select>
      </div>

      <div class="form-row">
        <label>Tax Filing Year:</label>
        <input class="form-control"
               name="filingYear"
               [(ngModel)]="uploadParams.filingYear"
               placeholder="YYYY"
               type="number"
               step="1"
               min="2000"
               max="9999"/>
      </div>

      <div class="form-row">
        <label>Schema Version:</label>
        <input class="form-control"
               name="schemaVersion"
               [(ngModel)]="uploadParams.schemaVersion"
               type="text"
               inputmode="numeric"
               pattern="[-+]?[0-9]*[.]?[0-9]+"/>
      </div>

      <div class="form-row">
        <label>Zip File for Schema:</label>
        <div class="form-row__file">
          <input type="file"
                 name="schemaZipFile"
                 accept=".zip"
                 (change)="onFileInputChange($event)"/>
          <!-- <div class="selected-file-name" *ngIf="selectedFile">{{ selectedFile.name }}</div> -->
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer upload-irs-modal-footer" [hidden]="minimise">
    <button class="save-button"
            type="button"
            [disabled]="uploading || !selectedFile || !uploadParams.schemaVersion"
            (click)="manualUpload()">
      @if (uploading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Upload
    </button>
    <button class="cancel-button" type="button" (click)="closeModal(true)">Cancel</button>
  </div>
</div>
